import { JSX } from 'react';
import { AccountAndBillingPage as SharedAccountAndBillingPage } from 'shared/accountAndBilling';
import useBillingHostProps from './useBillingHostProps';

export default function AccountAndBillingPage(): JSX.Element {
  const billingHostProps = useBillingHostProps();

  return <SharedAccountAndBillingPage {...billingHostProps} />;
}
